import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [RouterModule.forChild([
    {
      path: 'cliente-detalhar',
      data: { breadcrumb: '' },
      loadChildren: () => import('./cliente-detalhar-janela/cliente-detalhar-janela.module')
        .then(m => m.ClienteDetalharJanelaModule)
    },
    {
      path: 'comanda',
      data: { breadcrumb: '' },
      loadChildren: () => import('./comanda-detalhar-janela/comanda-detalhar-janela.module')
        .then(m => m.ComandaDetalharJanelaModule)
    },
    {
      path: 'cliente-ficha-resumo',
      data: { breadcrumb: '' },
      loadChildren: () => import('./cliente-ficha-resumo-janela/cliente-ficha-resumo-janela.module')
        .then(m => m.ClienteFichaResumoJanelaModule)
    },
    {
      path: 'item-servico-detalhe',
      data: { breadcrumb: '' },
      loadChildren: () => import('./item-servico-detalhe-janela/item-servico-detalhe-janela.module')
        .then(m => m.ItemServicoDetalheJanelaModule)
    },
    {
      path: 'item-produto-resumo',
      data: { breadcrumb: '' },
      loadChildren: () => import('./item-produto-resumo-janela/item-produto-resumo-janela.module')
        .then(m => m.ItemProdutoResumoJanelaModule)
    },
    {
      path: 'transferencia-credito',
      data: { breadcrumb: '' },
      loadChildren: () => import('./transferencia-credito-cliente-janela/transferencia-credito-cliente-janela.module')
        .then(m => m.TransferenciaCreditoClienteJanelaModule)
    },
    {
      path: 'resgate-pacote',
      data: { breadcrumb: '' },
      loadChildren: () => import('./resgate-pacote-janela/resgate-pacote-janela.module')
        .then(m => m.ResgatePacoteJanelaModule)
    }

  ])],
  exports: [RouterModule]
})
export class JanelasEmpresaRoutingModule { }
